import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPersonCopies } from '../services/personService'
import useNotifications from './useNotifications'

export default function usePersonCopies(personId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [personCopies, setPersonCopies] = useState()
  const [refetch, setRefetch] = useState(true)

  useEffect(() => {
    if (personId) {
      getPersonCopies(personId)
        .then((response) => {
          if (response.status === 200) {
            setPersonCopies(response.data)
          }
        })
        .catch((err) => {
          error(
            t('hooks.errors.gettingPersonCopies', {
              defaultValue: `Error getting person copies: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
  }, [error, personId, t, refetch])

  const refetchPersonCopies = () => setRefetch(!refetch)

  return { personCopies, refetchPersonCopies }
}
